import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

export const HeaderLeft = ({ className, children }: HTMLAttributes<HTMLDivElement>) => {
    return <div className={classNames(className, 'ds-header-left')}>{children}</div>;
};
